/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isNil from 'lodash/isNil';

import CommunicatorUtility from '../utility/communicator-utility';

/**
 * Komunikátor firmware zařízení pro Ki-Wi Server.
 */
class CommunicatorFirmware {
  /**
   * Vytvoří instanci.
   * @param {Object} config Konfigurace aplikace.
   * @returns {CommunicatorFirmware} Nová instance.
   */
  constructor(config) {
    this.config = config;
  }

  /**
   * Načte vhodné vydání firmware pro zařízení.
   * @param {CommunicatorSettings} communicatorSettings Komunikátor nastavení ze serveru.
   * @param {FirmwareInfo} firmwareInfo Informace o aktuálním firmware zařízení.
   * @returns {FirmwareRelease|null} Vydání firmware určené pro zařízení.
   */
  parse(communicatorSettings, firmwareInfo) {
    // Kontrola informací z aktuálního firmware.
    const { manufacturer, modelName, version } = firmwareInfo;
    if (isNil(manufacturer) || isNil(modelName) || isNil(version)) {
      return null;
    }
    // Kontrola nastavení příznaku deaktivace firmware na serveru.
    const disabled = CommunicatorUtility.parseBoolean(
      communicatorSettings.get('firmware.disabled')
    );
    if (disabled) {
      return null;
    }
    // Do této cesty jsou sdruženy informace odpovídající aktuálnímu firmware.
    const path = `firmware.${manufacturer}.${modelName}`;
    // Kontrola cesty k firmware.
    const url = CommunicatorUtility.parseString(
      communicatorSettings.get(`${path}.url`),
      { nil: null }
    );
    if (isNil(url)) {
      return null;
    }
    // Kontrola verze k firmware.
    const releaseVersion = CommunicatorUtility.parseString(
      communicatorSettings.get(`${path}.version`),
      { nil: null }
    );
    if (isNil(releaseVersion) || releaseVersion === version) {
      return null;
    }
    return {
      manufacturer,
      modelName,
      // Velikost firmware zatím na serveru určit nejde, ale je zde ta možnost.
      // Doplní se výchozí předpokládaná velikost firmware.
      size: this.config.firmware.defaultSize,
      url,
      version: releaseVersion
    };
  }
}

export default CommunicatorFirmware;
